<script setup>
import { ref, getCurrentInstance } from 'vue';
import textareaAutoGrow from '../../vue/directives/textareaAutoGrow';

const props = defineProps({
    options: Object,
});

const emit = defineEmits(['hide-modal']);

// In Vue 2.7 script setup, directives must be registered by naming
// the import 'vDirectivename' or by defining them in a constant.
const vTextareaAutoGrow = textareaAutoGrow;

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---
const subject = ref('');
const message = ref('');
const disabled = ref(false);

// --- Methods ---
const onSubmit = () => {
    disabled.value = true;

    store.dispatch('request/post', {
            url: 'api/SupportController/sendZendeskEmail',
            postData: {
                subject: subject.value,
                message: message.value
            }
        })
        .then(() => {
            disabled.value = false; // Reset the form for its next use
            subject.value = '';
            message.value = '';
            emit('hide-modal');
        })
        .catch(() => {
            disabled.value = false;
        });
};
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">How may we help you?</h4>

                <button type="button" class="btn-close" @click="$emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <p>Please fill in details below, and we'll get back to you as soon as possible.</p>

                <form @submit.prevent="onSubmit">
                    <fieldset class="form-fieldset">
                        <div class="mb-4">
                            <label class="form-label visually-hidden" for="">Subject</label>
                            <input v-model="subject" class="form-control" placeholder="Subject" required type="text">
                        </div>

                        <div class="mb-4">
                            <label class="form-label visually-hidden" for="">Message</label>
                            <textarea ref="field" v-model="message" v-textarea-auto-grow class="form-control"
                                      placeholder="Message" required/>
                        </div>

                        <div class="text-center">
                            <button :disabled="disabled" class="btn btn-light" type="submit">Submit</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>